<template>
    <div>
        <el-card class="box-card" v-if="showchart">
            <div class="title">案例</div>
            <el-row :gutter="20" class="mt15">
              <el-col :span="8">
                <div class="btns">
                  <el-button type="primary" @click="changePmubanurl(0)">模板1</el-button>
                  <el-button type="primary" @click="changePmubanurl(1)">模板2</el-button>
                  <el-button type="primary" @click="changePmubanurl(2)">模板3</el-button>
                  <el-button type="primary" @click="changePmubanurl(3)">模板4</el-button>
                  <el-button type="primary" @click="changePmubanurl(4)">模板5</el-button>
                  <el-button type="primary" @click="clicksavepic">下载</el-button>
                </div>
                <div class="case" ref="box">
                  <img class="caseimg1" src="../assets/images/pmb1.jpg" v-if="Pmubanindex == 0">
                  <img class="caseimg1" src="../assets/images/pmb2.jpg" v-if="Pmubanindex == 1">
                  <img class="caseimg1" src="../assets/images/pmb3.jpg" v-if="Pmubanindex == 2">
                  <img class="caseimg1" src="../assets/images/pmb4.jpg" v-if="Pmubanindex == 3">
                  <img class="caseimg1" src="../assets/images/pmb5.jpg" v-if="Pmubanindex == 4">
                  <img class="caseimg2" src="" id="caseimg2">
                  <div class="caseword">
                    <p class="casename">{{Name}}</p>
                    <p class="caseage">{{Age}}</p>
                    <p class="casearea">{{Province}} {{City}} {{District}}</p>
                    <p class="casesumyouxiaotime">{{Sumyouxiaotime}}</p>
                    <p class="casecreatetime">{{Createtime}}</p>
                    <p class="caserighteyedegreef">{{Lefteyedegreef}}</p>
                    <p class="caselefteyedegreef">{{Righteyedegreef}}</p>
                    <p class="caserighteyedegreel">{{Lefteyedegreel}}</p>
                    <p class="caselefteyedegreel">{{Righteyedegreel}}</p>
                    <p class="casenakedrighteyedegreef">{{Nakedlefteyedegreef}}</p>
                    <p class="casenakedlefteyedegreef">{{Nakedrighteyedegreef}}</p>
                    <p class="casenakedbinoculusdegreef">{{Nakedbinoculusdegreef}}</p>
                    <p class="casenakedrighteyedegreel">{{Nakedlefteyedegreel}}</p>
                    <p class="casenakedlefteyedegreel">{{Nakedrighteyedegreel}}</p>
                    <p class="casenakedbinoculusdegreel">{{Nakedbinoculusdegreel}}</p>
                    <p class="casecorrectrighteyedegreef">{{Correctlefteyedegreef}}</p>
                    <p class="casecorrectlefteyedegreef">{{Correctrighteyedegreef}}</p>
                    <p class="casecorrectbinoculusdegreef">{{Correctbinoculusdegreef}}</p>
                    <p class="casecorrectrighteyedegreel">{{Correctlefteyedegreel}}</p>
                    <p class="casecorrectlefteyedegreel">{{Correctrighteyedegreel}}</p>
                    <p class="casecorrectbinoculusdegreel">{{Correctbinoculusdegreel}}</p>
                    <p class="casenowtime">{{Nowtime}}</p>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-table :data="registrationDate" border stripe class="mt20">
                <el-table-column prop="Createtime" label="注册日期"></el-table-column>
                <el-table-column label="初始屈光度" align="center">
                    <el-table-column prop="Righteyedegreef" label="OD"></el-table-column>
                    <el-table-column prop="Lefteyedegreef" label="OS"></el-table-column>
                </el-table-column>
                <el-table-column label="初始裸眼视力" align="center">
                    <el-table-column prop="Nakedrighteyedegreef" label="OD"></el-table-column>
                    <el-table-column prop="Nakedlefteyedegreef" label="OS"></el-table-column>
                    <el-table-column prop="Nakedbinoculusdegreef" label="OU"></el-table-column>
                </el-table-column>
            </el-table>

            <div class="title mt20">统计时间</div>
            <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="75px" class="mt15">
                <el-form-item label="">
                    <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
                    <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clicksearch">查询</el-button>
                    <el-button type="info" @click="clickback">返回</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="reviewDate" border stripe>
                <el-table-column prop="Inputtime" label="复查日期"></el-table-column>
                <el-table-column label="最新复查屈光度" align="center">
                    <el-table-column prop="Righteyedegreel" label="OD"></el-table-column>
                    <el-table-column prop="Lefteyedegreel" label="OS"></el-table-column>
                </el-table-column>
                <el-table-column label="最新复查裸眼视力" align="center">
                    <el-table-column prop="Nakedrighteyedegree" label="OD"></el-table-column>
                    <el-table-column prop="Nakedlefteyedegree" label="OS"></el-table-column>
                    <el-table-column prop="Nakedbinoculusdegree" label="OU"></el-table-column>
                </el-table-column>
            </el-table>

            <ve-line :data="lineData1" class="mt15"></ve-line>
            <ve-line :data="lineData2" class="mt15"></ve-line>
        </el-card>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      keywords: {
        begintime: '',
        endtime: ''
      },
      Pmubanindex: 0,
      Pmubanurl: '',
      Avatarurl: '',
      Name: '',
      Age: '',
      Province: '',
      City: '',
      District: '',
      Sumyouxiaotime: '',
      Createtime: '',
      Righteyedegreef: '',
      Lefteyedegreef: '',
      Nakedrighteyedegreef: '',
      Nakedlefteyedegreef: '',
      Nakedbinoculusdegreef: '',
      Correctrighteyedegreef: '',
      Correctlefteyedegreef: '',
      Correctbinoculusdegreef: '',
      Righteyedegreel: '',
      Lefteyedegreel: '',
      Nakedrighteyedegreel: '',
      Nakedlefteyedegreel: '',
      Nakedbinoculusdegreel: '',
      Correctrighteyedegreel: '',
      Correctlefteyedegreel: '',
      Correctbinoculusdegreel: '',
      Nowtime: '',
      registrationDate: [
        {
          Createtime: '',
          Righteyedegreef: '',
          Lefteyedegreef: '',
          Nakedrighteyedegreef: '',
          Nakedlefteyedegreef: '',
          Nakedbinoculusdegreef: ''
        }
      ],
      reviewDate: [],
      lineData1: {
        columns: ['Inputtime', '右眼球镜', '左眼球镜'],
        rows: []
      },
      lineData2: {
        columns: ['Inputtime', '右眼5米裸眼视力', '左眼5米裸眼视力', '双眼5米裸眼视力'],
        rows: []
      },
      showchart: false,
      parentdata: null
    }
  },
  mounted () {
    this.changePmubanurl(0)
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.showchart = true
      this.clicksearch()
    },
    clicksearch () {
      this.apiGetAnnualReportinfo()
    },
    clickback () {
      this.showchart = false
      this.$emit('triggerFunc', '')
    },
    changePmubanurl (index) {
      this.Pmubanindex = index
    },
    clicksavepic () {
      var that = this
      html2canvas(that.$refs.box, {
        useCORS: true,
        allowTaint: false
      }).then(function (canvas) {
        var a = document.createElement('a')
        a.href = canvas.toDataURL('image/jpeg')
        a.download = that.Name
        a.click()
        a.remove()
      })
    },
    apiGetAnnualReportinfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAnnualReportinfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.Avatarurl = response.data.Avatarurl
            that.getImage(that.Avatarurl, 'caseimg2')
            that.Name = response.data.Name
            that.Age = response.data.Age
            that.Province = response.data.Province
            that.City = response.data.City
            that.District = response.data.District
            that.Sumyouxiaotime = response.data.Sumyouxiaotime
            that.Createtime = response.data.Createtime
            that.Righteyedegreef = response.data.Righteyedegreef
            that.Lefteyedegreef = response.data.Lefteyedegreef
            that.Nakedrighteyedegreef = response.data.Nakedrighteyedegreef
            that.Nakedlefteyedegreef = response.data.Nakedlefteyedegreef
            that.Nakedbinoculusdegreef = response.data.Nakedbinoculusdegreef
            that.Correctrighteyedegreef = response.data.Correctrighteyedegreef
            that.Correctlefteyedegreef = response.data.Correctlefteyedegreef
            that.Correctbinoculusdegreef = response.data.Correctbinoculusdegreef
            that.Righteyedegreel = response.data.Righteyedegreel
            that.Lefteyedegreel = response.data.Lefteyedegreel
            that.Nakedrighteyedegreel = response.data.Nakedrighteyedegreel
            that.Nakedlefteyedegreel = response.data.Nakedlefteyedegreel
            that.Nakedbinoculusdegreel = response.data.Nakedbinoculusdegreel
            that.Correctrighteyedegreel = response.data.Correctrighteyedegreel
            that.Correctlefteyedegreel = response.data.Correctlefteyedegreel
            that.Correctbinoculusdegreel = response.data.Correctbinoculusdegreel
            that.Nowtime = response.data.Nowtime
            that.registrationDate[0].Createtime = response.data.Createtime
            that.registrationDate[0].Righteyedegreef = response.data.Righteyedegreef
            that.registrationDate[0].Lefteyedegreef = response.data.Lefteyedegreef
            that.registrationDate[0].Nakedrighteyedegreef = response.data.Nakedrighteyedegreef
            that.registrationDate[0].Nakedlefteyedegreef = response.data.Nakedlefteyedegreef
            that.registrationDate[0].Nakedbinoculusdegreef = response.data.Nakedbinoculusdegreef
            that.reviewDate = response.data.List

            that.lineData1.rows = []
            response.data.List.filter((item1, i1) => {
              that.lineData1.rows.push({ Inputtime: item1.Inputtime, 右眼球镜: item1.Righteyedegree, 左眼球镜: item1.Lefteyedegree })
            })

            that.lineData2.rows = []
            response.data.List.filter((item1, i1) => {
              that.lineData2.rows.push({ Inputtime: item1.Inputtime, 右眼5米裸眼视力: item1.Nakedrighteyedegree, 左眼5米裸眼视力: item1.Nakedlefteyedegree, 双眼5米裸眼视力: item1.Nakedbinoculusdegree })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    getImage: function (url, imgId) {
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status === 200) {
          document.getElementById(imgId).src = URL.createObjectURL(this.response)
        }
      }
      xhr.send()
    }
  }
}
</script>

<style lang="less" scoped>
.case{
    width: 1181px;
    height: 1772px;
    position: relative;
}

.caseimg1{
  width: 1181px;
  height: 1772px;
  position: absolute;
  z-index: 10;
}

.caseimg2{
  width: 701px;
  height: 701px;
  position: absolute;
  z-index: 20;
  left: 240px;
  top: 160px;
}

.caseword{
  color:#000000;
  font-size: 30px;
}

.casename{
  position: absolute;
  z-index: 30;
  left: 225px;
  top: 1018px;
}

.caseage{
  position: absolute;
  z-index: 30;
  left: 455px;
  top: 1018px;
}

.casearea{
  position: absolute;
  z-index: 30;
  left: 750px;
  top: 1018px;
}

.casesumyouxiaotime{
  position: absolute;
  z-index: 30;
  left: 285px;
  top: 1095px;
}

.casecreatetime{
  position: absolute;
  z-index: 30;
  left: 745px;
  top: 1095px;
}

.caserighteyedegreef{
  position: absolute;
  z-index: 30;
  left: 175px;
  top: 1298px;
}

.caselefteyedegreef{
  position: absolute;
  z-index: 30;
  left: 175px;
  top: 1235px;
}

.caserighteyedegreel{
  position: absolute;
  z-index: 30;
  left: 665px;
  top: 1298px;
}

.caselefteyedegreel{
  position: absolute;
  z-index: 30;
  left: 665px;
  top: 1235px;
}

.casenakedrighteyedegreef{
  position: absolute;
  z-index: 30;
  left: 220px;
  top: 1498px;
}

.casenakedlefteyedegreef{
  position: absolute;
  z-index: 30;
  left: 220px;
  top: 1440px;
}

.casenakedbinoculusdegreef{
  position: absolute;
  z-index: 30;
  left: 220px;
  top: 1555px;
}

.casenakedrighteyedegreel{
  position: absolute;
  z-index: 30;
  left: 460px;
  top: 1498px;
}

.casenakedlefteyedegreel{
  position: absolute;
  z-index: 30;
  left: 460px;
  top: 1440px;
}

.casenakedbinoculusdegreel{
  position: absolute;
  z-index: 30;
  left: 460px;
  top: 1555px;
}
//

.casecorrectrighteyedegreef{
  position: absolute;
  z-index: 30;
  left: 710px;
  top: 1498px;
}

.casecorrectlefteyedegreef{
  position: absolute;
  z-index: 30;
  left: 710px;
  top: 1440px;
}

.casecorrectbinoculusdegreef{
  position: absolute;
  z-index: 30;
  left: 710px;
  top: 1555px;
}

.casecorrectrighteyedegreel{
  position: absolute;
  z-index: 30;
  left: 945px;
  top: 1498px;
}

.casecorrectlefteyedegreel{
  position: absolute;
  z-index: 30;
  left: 945px;
  top: 1440px;
}

.casecorrectbinoculusdegreel{
  position: absolute;
  z-index: 30;
  left: 945px;
  top: 1555px;
}

.casenowtime{
  position: absolute;
  z-index: 30;
  left: 965px;
  top: 1595px;
  transform: rotate(-30deg);
}
</style>
